import React from 'react'
import { IIconProps } from './Icon/Interfaces'

const AttachmentIcon = ({
  width=19,
  height=20,
  strokeColor='var(--blue)',
}: IIconProps) => {
  return (
    <svg fill="none" viewBox="0 0 19 20" height={height} width={width}>
      <path
        fill={strokeColor}
        d="M14.025.037C12.78.214 12 .97 11.145 1.814L9.332 3.608C7.365 5.55 5.419 7.514 3.453 9.457l-1.578 1.56c-.532.525-1.07 1.067-1.386 1.754-1.043 2.273-.396 4.985 1.741 6.404.433.288.92.495 1.42.637 1.504.424 3.155.118 4.419-.78.802-.571 1.472-1.361 2.17-2.05 1.833-1.813 3.648-3.646 5.483-5.459.914-.904 1.844-1.794 2.725-2.73.144-.152.319-.288.43-.467a.872.872 0 0 0-.087-1.012c-.365-.403-.951-.324-1.332.005-.939.812-1.762 1.773-2.644 2.644L9.568 15.15c-.547.54-1.072 1.098-1.618 1.638-.336.332-.67.68-1.065.946-1.385.932-3.327.66-4.387-.634-.932-1.14-1.074-2.764-.183-3.977.339-.461.771-.847 1.177-1.248l1.855-1.833C7.18 8.228 8.995 6.396 10.83 4.583l1.617-1.599c.304-.3.596-.65.947-.895a2.059 2.059 0 0 1 2.012-.195c1.19.524 1.604 2.053.82 3.079-.263.342-.592.633-.899.935l-1.42 1.404-4.458 4.406c-.618.61-1.232 1.225-1.854 1.832-.3.294-.678.564-1.104.335a.98.98 0 0 1-.268-.218c-.565-.642.229-1.248.662-1.676l3.156-3.12c.427-.421.924-.97.419-1.555-.246-.285-.713-.366-1.05-.199-.439.217-.801.714-1.144 1.053l-.395.39-2.209 2.183c-.438.433-.953.856-1.18 1.443-.553 1.422.204 3.108 1.772 3.444.368.08.735.078 1.104.008.753-.143 1.254-.636 1.776-1.152l1.262-1.247 5.168-5.108c.904-.894 2.056-1.763 2.546-2.964.557-1.361.22-3.004-.814-4.053-.832-.845-2.092-1.244-3.27-1.077z"
      />
    </svg>
  )
}

export default AttachmentIcon
